<template>
    <div class="test-wrapper">
        <div class="test_menu">
            <div class="question_number"><b><span class="current_num">{{currentNumQues}}</span> / <span>{{questions.length}}</span></b>
            </div>
            <div class="timer">
                <img src="/upload/bkc_test/test_timer.png">
                <div>
                    <b>
                        <span class="afss_mins_bv">{{timerGet.min}}</span>&nbsp;:&nbsp;
                        <span class="afss_secs_bv">{{timerGet.sec}}&nbsp;</span>
                    </b>
                </div>

            </div>

            <div class="quit"><a style="color: #555;" href="/quiz/quit_test.php" class="window-link"><img
                    src="/upload/bkc_test/test_red-exit.png"><b>Выход</b></a></div>
        </div>

        <div class="condition"><b>Условие задания:</b> <span>{{current.condition}}</span>
        </div>

        <div class="test_question" v-html="current.quest"></div>

        <div class="form-input" style="margin:40px auto;"
             v-if="current.answers == 'false' || current.answers == false ">
            <label>

                <input name="answer" v-model="answer"
                       :disabled="(current.answer != '' && (current.completed == true || current.completed == 'true'))"
                       type="text" aria-required="true">
            </label>
        </div>

        <div class="option-wrapper" v-if="current.answers !== 'false'">
            <div class="option-block"
                 v-for="(answer, index) in current.answers"
                 @click="checkAnswer(answer, $event)"
                 :class="[(answer == current.answer) ? 'active' : '']">
                <div id="option_A" class="option" v-if="index === 0"
                     :class="[(answer == current.answer) ? 'active-option' : '']">{{answer}}
                </div>
                <div id="option_B" class="option" v-if="index === 1"
                     :class="[(answer == current.answer) ? 'active-option' : '']">{{answer}}
                </div>
                <div id="option_C" class="option" v-if="index === 2"
                     :class="[(answer == current.answer) ? 'active-option' : '']">{{answer}}
                </div>
                <div id="option_D" class="option" v-if="index === 3"
                     :class="[(answer == current.answer) ? 'active-option' : '']">{{answer}}
                </div>
            </div>
        </div>

        <div class="button-wrapper">
            <div class="test-next">
                <div class="form-submit" :class="{checked: !isChecked}" @click="nextQuest">
                    <input :disabled="(current.answer != '' && (current.completed == true || current.completed == 'true') ) || this.disableContinue"
                           type="submit" value="Продолжить"/>
                </div>
            </div>
        </div>


        <div style="" class="carousel-wrapper">
            <div class="questions-carousel owl-carousel owl-theme">
                <div class="item" v-for="(answer, index) in questions"
                     :class="classPage(answer, index)"
                     @click="loadQuest(index, answer)">
                    {{index + 1}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios'

    export default {
        name: 'Test',
        data() {
            return {
                questions: [],
                currentQuest: {},
                answer: null,
                activeIndex: 0,
                minutesToEnd: 1,
                secondsToEnd: 0,
                currentKey: null,
                disableContinue: true
            }
        },
         mounted: function () {
             this.scrollToTest();
             $('body').on('click', '#info-block2 .yes', () => {
                $('.window-close').trigger('click');
                this.nextSteep();
            });
            axios.get(`/quiz/api/test.php?get_questions`).then(response => {
                if (response.data.questions == false) {
                    alert('Произошла ошибка во время загрузки вопросов');
                    this.$router.push(`/`);
                    return false;
                }

                this.questions = response.data;
                let Today = new Date();
                let ms = Today.getTime();
                let seconds = (parseInt(response.data[0]['time_to_test']) - ms) / 1000;
                this.minutesToEnd = Math.trunc(seconds / 60);
                this.secondsToEnd = Math.trunc(seconds % 60);
                this.detectActiveQuest();
                this.timer();
            }).catch(error => {
                console.log(error)
            });
        },
        computed: {
            timerGet: function () {
                return {
                    min: this.minutesToEnd,
                    sec: this.secondsToEnd
                };
            },
            current: function () {
                return this.currentQuest;
            },
            currentNumQues: function () {
                return this.activeIndex + 1
            },
            isChecked: function () {
                let complite = false;

                if (this.currentQuest === true || this.currentQuest === 'true') {
                    complite = true;
                }
                return this.answer !== null && complite == false;
            },
            isActivePage: function (index) {
                return index === this.activeIndex
            }
        },
        methods: {
            scrollToTest: function(){
                $('html, body').animate({ scrollTop: $('.container-test').offset().top }, 0); // анимируем скроолинг к элементу scroll_el
            },
            nextSteep: function () {
                this.$router.push(`/preloader`);
            },

            initPaginate: function () {
                setTimeout(() => {
                    $(function () {
                        $('.questions-carousel').owlCarousel({
                            nav: true,
                            navText: [
                                "<img src='/upload/slider-arrows/bkc_left-arrow.png'>",
                                "<img src='/upload/slider-arrows/bkc_right-arrow.png'>"
                            ],
                            items: 7,
                            dots: false,
                            loop: false,
                            margin: 5,

                            responsive : {
                              320 : {
                                items: 5,
                              },
                              500 : {
                                items: 7,
                              }
                            }
                        });
                    });
                }, 1000)
            },

            classPage: function (answer, index) {
                if (this.activeIndex == index) {
                    return 'current';
                }

                if (answer.completed == "true" || answer.completed == true) {
                    return 'checked';
                }

                if (answer.group_id !== this.currentKey) {
                    return 'unavailable';
                }

                return '';
            },

            timer: function () {
                this.secondsToEnd--;

                if (this.secondsToEnd == '-01') {
                    this.secondsToEnd = 59;
                    this.minutesToEnd = parseInt(this.minutesToEnd) - 1;
                }
                else {
                    this.minutesToEnd = this.minutesToEnd;
                }
                if (this.secondsToEnd <= 9) {
                    this.secondsToEnd = "0" + this.secondsToEnd;
                }
                this.minutesToEnd = (this.minutesToEnd <= 9 ? "0" + parseInt(this.minutesToEnd) : this.minutesToEnd);

                let inter = setTimeout(this.timer, 1000);

                if (this.secondsToEnd == '00' && this.minutesToEnd == '00') {
                    clearInterval(inter);
                    this.nextSteep();
                }
            },
            detectActiveQuest: function (check) {
                this.answer = null;
                for (let i = 0, max = this.questions.length; i < max; i++) {
                    if (this.questions[i]['completed'] == false || this.questions[i]['completed'] == 'false') {
                        this.currentQuest = this.questions[i];
                        this.activeIndex = i;
                        this.currentKey = this.questions[i]['group_id'];
                        this.answer = this.questions[this.activeIndex]['answer'];

                        this.initPaginate();

                        return true;
                    }
                }
                this.initPaginate();

                if (check) {
                    this.nextSteep();
                }

            },
            checkAnswer: function (answer, e) {
                if (this.questions[this.activeIndex]['completed'] == true || this.questions[this.activeIndex]['completed'] == 'true') {
                    return false;
                }
                let $this = $(e.currentTarget);
                this.answer = answer;
                this.questions[this.activeIndex]['answer'] = answer;

                $('.option-block').removeClass('active');
                $('.option-block div').removeClass('active-option');
                $this.addClass('active');
                $this.find('div').addClass('active-option');
            },
            loadQuest: function (index, answer) {
                if (answer.group_id != this.currentKey) {
                    return false
                }
                this.currentQuest = this.questions[index];
                this.activeIndex = index;
                this.answer = this.questions[this.activeIndex]['answer'];
            },
            nextQuest: function () {
                if (this.isChecked) {
                    this.questions[this.activeIndex]['completed'] = true;
                    $.ajax({
                        url: '/quiz/api/test.php?update_questions',
                        'type': 'POST',
                        'dataType': 'json',
                        data: {
                            questions: this.questions,
                            key: this.currentKey
                        },
                        success: data => {
                            if (data['end']) {
                                this.nextSteep();
                                return false;
                            }
                            $('.owl-next').trigger('click');
                            this.detectActiveQuest(true)
                        },
                        error: error => {
                            alert('error');
                        }
                    });
                } else {
                    alert('Нет ответа');
                }
            }
        },
        watch: {
            answer: function (answer) {
                this.questions[this.activeIndex]['answer'] = answer;
                this.disableContinue = this.questions[this.activeIndex]['answer'] == '' ? true : false;

            },
            activeIndex: function () {
                this.scrollToTest();
            }
        }
    }

    $(function () {
        $(document.body).on('click', '#info-block2 .no', function () {
            $('.window-close').trigger('click');
        })
    });
</script>

<style scoped lang="sass">
    .option-block
        &.active
            .option
                border: 2px solid #6ed9de
                &:before
                    margin-top: -2px
                    margin-left: -2px
                    color: #000
                    border: 2px solid #6ed9de
        .questions-carousel
            .current
                background: #f8fa00 !important

</style>



// WEBPACK FOOTER //
// src/components/Test.vue